export const HomeFeatures = [
  'Primera Inscripción Vehicular',
  'Seguro Obligatorio de Accidentes Personales (SOAP)',
  'Certificado de Homologación Electrónico (CHI-e)',
  'Permiso de Circulación Vehicular (PCV)',
  'Obtención de TAG'
];

export const HomeBenefits = [
  {title: 'Sencilla', description: 'Completamente en línea y podrás elegir la terminación de tu Placa.'},
  {
    title: 'Transparente',
    description: 'Recibirás todos los documentos en tu correo electrónico. Además, podrás ir revisando el estado de tu trámite.'
  },
  {
    title: 'Cómoda',
    description: 'Despacharemos las placas patentes junto con la documentación en el local de compra del vehículo.'
  },
];

export const HomeQuestions = [
  {
    title: '¿Cómo solicitar cotización de servicios para mi vehículo?',
    question: 'Debes presionar el botón Solicitar, llenar los datos solicitados en el formulario y adjuntar la factura.'
  },
  {
    title: '¿Cómo realizo el pago del plan que elijo?',
    question: 'Una vez solicitada la cotización debe seleccionar el medio de pago, revisar el resumen y presionar el botón Pagar. Posteriormente, te será enviado un correo con un enlace seguro para efectuar el pago electrónico.'
  },
  {
    title: '¿Cómo puedo hacer seguimiento de los servicios solicitados?',
    question: 'Mediante el correo electrónico te será notificado el avance de los servicios solicitados y serán adjuntados los documentos que se generen.'
  },
  {
    title: '¿Qué función tiene la Billetera Electrónica?',
    question: 'Permite al propietario visualizar y gestionar los documentos de su vehículo de forma ordenada y sencilla.'
  },
  {
    title: '¿Cuándo se muestra mi vehículo en la Billetera Electrónica?',
    question: 'Al terminar el proceso de auto inscripción de forma satisfactoria.'
  },
  {
    title: '¿Cómo puedo acceder a la Billetera Electrónica?',
    question: 'Accediendo a la aplicación Id Auto Wallet mediante el link: https://wallet.idauto.cl'
  },
];
